/**
 * Supported language codes for the web admin.
 * Keep in sync with backend/services/languages.py and src/constants/languages.js.
 */
export const DEFAULT_BACKEND_LANGUAGE = 'en';

export const SUPPORTED_BACKEND_CODES = ['en', 'es-mx'];

/** i18next resource keys used in backend/web/src/i18n/index.js */
export const I18N_EN = 'en-US';
export const I18N_ES_MX = 'es-MX';

const ACCEPT_LANGUAGE = {
  en: 'en-us',
  'es-mx': 'es-mx',
};

/**
 * Normalize i18next / localStorage codes to canonical web UI locales.
 * Legacy 'en' and variants map to en-US; any Spanish variant maps to es-MX.
 */
export function normalizeI18nLanguage(language) {
  if (!language) {
    return I18N_EN;
  }
  const lng = String(language).toLowerCase().replace('_', '-');
  if (lng.startsWith('es')) {
    return I18N_ES_MX;
  }
  return I18N_EN;
}

/** Map UI language to backend code (en | es-mx). */
export function languageToBackendCode(language) {
  const lng = (language || DEFAULT_BACKEND_LANGUAGE).toLowerCase().replace('_', '-');
  if (lng.startsWith('es')) {
    return 'es-mx';
  }
  return DEFAULT_BACKEND_LANGUAGE;
}

/** Map UI language to HTTP Accept-Language header value. */
export function languageToAcceptLanguage(language) {
  return ACCEPT_LANGUAGE[languageToBackendCode(language)];
}

export function isSpanishLocale(language) {
  return languageToBackendCode(language) === 'es-mx';
}

/** Key for local toast message objects in apis/index.js (en | es). */
export function toastMessageKey(language) {
  return isSpanishLocale(language) ? 'es' : 'en';
}
